// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as React from "react";
import * as TextStyle from "../../resources/typography/TextStyle.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as StockActivityReason from "./StockActivityReason.res.js";

function StockActivityTypeTableCell(props) {
  let reason = props.reason;
  let kind = props.value;
  return JsxRuntime.jsx(Box.make, {
    children: JsxRuntime.jsx(TextStyle.make, {
      children: reason !== undefined && reason !== "LOSS" ? kind + " > " + StockActivityReason.toLabel(reason) : kind
    }),
    spaceY: "normal"
  });
}

let make = React.memo(StockActivityTypeTableCell);

export {
  make,
}
/* make Not a pure module */
